import {defineStore} from 'pinia'
import api from "../../../../vendor/xkit/js/api.js";
import Validations from '../../../../vendor/xkit/validations/js/validations'
import {
	delay
} from "lodash";
import {
	nextTick
} from "vue";

let $ = jQuery

export const useModalStore = defineStore('xkit-modal', {
	state: () => {

		return {
			modals: {}
		}
	},
	actions: {
		async open_modal( modal_id, state = null ) {
			let $modal = $('#xkit-modal-' + modal_id)

			if ( state ) {
				if ( state.title ) {
					$( '.modal-title', $modal ).html( state.title )
				}
				this.modals[modal_id].state = Object.assign( this.modals[modal_id].state, state )
			}

			// $modal.dialog( "option", "position", { my: "top", at: "top+5%", of: window, collision: 'fit' } );
			bootstrap.Modal.getOrCreateInstance($modal[0]).show()

			await this.set_modal_content( modal_id )
			nextTick(function () {
				// $modal.dialog( "option", "position", { my: "top", at: "top+5%", of: window, collision: 'fit' } );
				if ( typeof init_xkit_selects != 'undefined' ) {
					init_xkit_selects()
				}
			})

			$(document).trigger('xkit-open-modal', $modal )
		},
		async set_modal_content( modal_id ) {
			let modal = this.modals[modal_id]
			let $modal = $('#xkit-modal-' + modal_id)
			// Check if we have cached content.
			/*if ( modal.html ) {
				return new Promise( ( success,error) => {
					success( modal.html);
				});
			}*/

			XKIT_Utils.blockUI( $modal )
			await api.post( { action: modal.state.form_url, ...modal.state } ).then( (res) => {
				$modal.unblock()
				if ( res.data.err ) {
					alert( res.data.html )
					return;
				}

				$( '.modal-body', $modal).html( res.data.html )
				$(document).trigger('xkit-set-modal-content', $modal )
			})
		},
		async submit_modal( modal_id, e ) {
			let $modal = $('#xkit-modal-' + modal_id)

			if ( typeof tinyMCE != 'undefined' ) {
				tinyMCE.triggerSave();
			}

			let $form = $modal.find('form')
			let data = $form.serializeArray()

			let checks = new Validations( { fields: $form.find(':required').toArray().map( i => '#' + i.id ) , $wrapper: $form })

			if ( ! checks.check() ) {
				return;
			}

			XKIT_Utils.blockUI( $modal )
			api.post( data ).then( (res) => {
				if ( !res.data.reload ) {
					$modal.unblock()
				}
				if ( res.data.err ) {
					alert( res.data.html )
					return;
				}

				if ( res.data.html ) {
					$( '.modal-body', $modal).html( res.data.html )
					$( document ).trigger( 'xkit-set-modal-content', $modal )
				}

				let $before_event = new jQuery.Event( 'xkit-before-close-modal', {cancelable: true, originalEvent: e } )
				$( document ).trigger( $before_event, { $modal, posted_data: data, res } )
				if ( $before_event.isDefaultPrevented() ) {
					return
				}

				if ( res.data.reload ) {
					window.location.reload()
					return;
				}

				if ( typeof res.data.close_dialog == 'undefined' ) {
					bootstrap.Modal.getOrCreateInstance($modal[0]).hide()
				}
			})
		},

	},
	// getters: {
	// 	get_sections: (state) => {
	// 		return Object.entries( state.services ).filter( (id, i) => i.section == null )
	// 	},
	// }
})